const getRandomInt = max => Math.floor(Math.random() * max + 1);

export const getRandomColor = (opacity = 1) => {
    const rgb = [220, 220, 220].map(getRandomInt).map(String).join(', ');
    return `rgba(${rgb}, ${opacity})`;
};